import React, { Component } from 'react';
import { validateText, validateEmailAddress } from '../../utils/validate';
import ReCAPTCHA from 'react-google-recaptcha';




class DiscountForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formFulfilled: false,
            captcha: {},
            modalIsOpen: false,
            formErrors: {
                firstName: '',
                lastName: '',
                email: ''
            },
        }
        this.captcha = {};
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.validateForm = this._validateForm.bind(this);
        this.handleChange = this._handleChange.bind(this);
        this.handleSubmit = this._handleSubmit.bind(this);
        this.handleEnter = this._handleEnter.bind(this);
        this.setCaptchaObject = this._setCaptchaObject.bind(this);
        this.getRecaptcha = this._getRecaptcha.bind(this);
    }

    componentDidMount() {
        this.captcha.execute();
    }


    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    _handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
            formErrors: {
                ...this.state.formErrors,
                [event.target.name]: ''
            }
        });
    }

    _handleEnter(event) {
        event.key === 'Enter' && this.handleSubmit(event);
    }



    _validateForm() {

        // clone the formErrors object
        const formErrors = Object.assign({}, this.state.formErrors);

        // validate each field
        for (let field of Object.keys(formErrors)) {
            const value = this.state[field];

            if (!validateText(value)) {
                formErrors[field] = 'This field is required';
            }
            else if (field === 'email' && !validateEmailAddress(value)) {
                formErrors[field] = 'Your email address is invalid';
            }
            else {
                formErrors[field] = '';
            }
        }

        this.setState({
            formErrors
        });

        return !Object.values(formErrors).filter(value => !!value).length;
    }

    _handleSubmit(event) {

        event.preventDefault();

        if (this.validateForm()) {
            const fields = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
            };
            this.props.submitAction(fields, this.state.captcha);
        }
    }
    _setCaptchaObject(grecaptcha) {
        this.captcha = grecaptcha;
    }

    _getRecaptcha(response) {

        this.setState({
            captcha: response,
        });

    }
    render() {
        return (
            <div className={''}>
                <form name="discount_form" onSubmit={this.handleSubmit} id="mentor-form">
                    <h3 className="text-left">Please fill out this form to claim your discount code</h3>
                    <br />
                    <div className="row text-center">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="firstname" style={{ position: 'absolute', left: '-100000px' }} >First Name:</label>
                                <input name="firstName" onChange={this.handleChange} type="text" className="form-control" id="firstname" placeholder={'First Name'} onKeyPress={this.handleEnter} required />
                                <span className="bmd-help"></span>
                                {this.state.formErrors.firstName ? <div className={'alert alert-danger'}>{this.state.formErrors.firstName}</div> : ''}
                            </div>
                        </div>
                    </div>

                    <div className="row text-center">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="lastName" style={{ position: 'absolute', left: '-100000px' }} >Last Name:</label>
                                <input name="lastName" onChange={this.handleChange} type="text" className="form-control" id="firstname" placeholder={'Last Name'} onKeyPress={this.handleEnter} required />
                                <span className="bmd-help"></span>
                                {this.state.formErrors.firstName ? <div className={'alert alert-danger'}>{this.state.formErrors.firstName}</div> : ''}
                            </div>
                        </div>

                    </div>

                    <div className="row text-center">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="email" style={{ position: 'absolute', left: '-100000px' }} >Email:</label>
                                <input name="email" type="email" className="form-control" id="email" placeholder={'Email'} onKeyPress={this.handleEnter} onChange={this.handleChange} required />
                                <span className="bmd-help"></span>
                                {this.state.formErrors.email ? <div className={'alert alert-danger'}>{this.state.formErrors.email}</div> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="row">

                    </div>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <button name="submit" className="btn btn-mid-orange ubuntu" type="submit" onClick={this.handleSubmit}>
                                <span>Submit Form</span>
                                <div className={'ripple-container'}></div>
                            </button>
                            <span>&nbsp;</span>
                            <button name="submit" className="btn btn-mid-orange ubuntu"
                                onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() && this.props.cancelAction }}
                                onClick={this.props.cancelAction}>
                                <span>Cancel</span>
                                <div className={'ripple-container'}></div>
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <ReCAPTCHA
                                ref={(el) => { this.setCaptchaObject(el); }}
                                sitekey={'6LebkXUUAAAAAHkSkfHPiEi8eZAv25K3W8YDzSVG'}
                                onChange={this.getRecaptcha}
                                size='invisible'
                                className={'center'}
                                data-style={'topright'}
                            />
                        </div>
                    </div>
                </form>
            </div>
        );

    }
}

export default DiscountForm;